import { useState } from 'react';

import FrequencyText from 'common/components/clubMembership/FrequencyText';

// eslint-disable-next-line import/no-cycle
import EditFrequencyModal from './EditFrequencyModal';

const FrequencyDetails = (props) => {
  const { clubMembership } = props;

  const [modal, setModal] = useState(null);

  const onModal = (modalName) => {
    setModal(modalName);
  };

  const onCloseModal = () => {
    setModal(null);
  };

  const handleEditFrequency = (e) => {
    e.preventDefault();
    onModal('editFrequency');
  };

  if (clubMembership.club.type !== 'Subscription') {
    return null;
  }

  return (
    <>
      <strong>Frequency</strong>
      <br />
      <FrequencyText frequency={clubMembership.subscription.frequency} />
      <br />
      <a onClick={handleEditFrequency} className="c7-button-alt-small">
        Edit
      </a>
      <Modal modal={modal} object={{ clubMembership, onCloseModal }} />
    </>
  );
};

const Modal = (props) => {
  const { modal, object } = props;
  const { clubMembership, onCloseModal } = object;
  switch (modal) {
    case 'editFrequency': {
      return (
        <EditFrequencyModal
          onCloseModal={onCloseModal}
          clubMembership={clubMembership}
        />
      );
    }
    default: {
      return null;
    }
  }
};

export default FrequencyDetails;
